import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { DealerUserService } from '../../services/dealer-user/dealer-user.service';
import { ModuleAccessService } from '../../services/module-access/module-access.service'; // Assuming this service exists

export const managerGuard: CanActivateFn = (): Observable<boolean> => {
  const moduleAccessService = inject(ModuleAccessService);
  const dealerUserService = inject(DealerUserService);
  const router = inject(Router);

  return moduleAccessService.newSite$.pipe(
    take(1),
    switchMap((newSite) => {
      if (newSite) {
        console.log(
          '%c New Site is enabled: skip managerGuard',
          'background: green; color: white',
        );
        return of(true);
      }

      return dealerUserService.currentDealerUser_IsManagerOrOwner$.pipe(
        take(1),
        tap(() => {
          console.log(
            '%c * Route uses Manager guard * ',
            'background: black; color: white',
          );
        }),
        map((isManagerOrOwner) => {
          if (isManagerOrOwner) {
            console.log(
              '%c DealerUser is Manager (or Owner) > allowed ',
              'background: green; color: white',
            );
            return true;
          }

          console.log(
            '%c DealerUser is not an Owner or Manager ',
            'background: red; color: white',
          );
          router.navigate(['/dashboard']);
          return false;
        }),
      );
    }),
  );
};
